<ng-container *transloco="let t">
  <div class="flex items-center justify-center bg-primary-tint-soft rounded-[1.25rem] size-16 md:size-24 shrink-0">
    <mat-icon svgIcon="minimalistic-magnifier-outline" class="size-9! md:size-13! text-primary!"></mat-icon>
  </div>
  <div class="flex flex-col items-center px-3 text-center gap-3 max-w-120">
    <p class="text-xl md:text-2xl font-semibold text-ink tracking-[0.24px]">{{ t('NO-RESULTS') }}</p>
    <p class="text-sm md:text-base text-ink-secondary leading-5 md:leading-6 tracking-[0.16px]">
      {{ t('NO-RESULTS-DESCRIPTION') }}
    </p>
  </div>
</ng-container>
